import { captureException } from '@sentry/react'
import { fetchAuthSession } from 'aws-amplify/auth'

export const HEADER_PREFIX = 'Bearer'

/** JSON Object type */
interface JsonObject {
  [x: string]: JsonPrimitive | JsonArray | JsonObject;
}
export type JwtPayload = JwtPayloadStandardFields & JsonObject
export interface JWT {
  payload: JwtPayload;
  toString(): string;
}

function isTokenToExpire(accessToken: JWT) {
  if (!accessToken) return true
  const secondsToExpire = 60
  const currentTime = Math.floor(Date.now() / 1000)
  const expireTime = accessToken.payload.exp
  return expireTime - currentTime < secondsToExpire
}

export async function getToken() {
  try {
    let session = await fetchAuthSession()
    if (isTokenToExpire(session?.tokens?.accessToken)) {
      session = await fetchAuthSession({ forceRefresh: true })
    }
    return session?.tokens?.accessToken?.toString()
  } catch (error) {
    captureException(error)
    return null
  }
}
